import { render, staticRenderFns } from "./DocumentosCollapse.vue?vue&type=template&id=c4a6cc2c&scoped=true&"
import script from "./DocumentosCollapse.vue?vue&type=script&lang=js&"
export * from "./DocumentosCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a6cc2c",
  null
  
)

export default component.exports